import axios from "axios";

export const wlApi = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api/wl`,
  withCredentials: true,
});

export const wlAdminApi = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api/wl/admin`,
  withCredentials: true,
});

export function apiError(err, fallback = "Something went wrong — please try again") {
  const d = err?.response?.data?.detail;
  if (d == null) return fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => (e && typeof e.msg === "string" ? e.msg : "")).filter(Boolean).join(" ") || fallback;
  if (typeof d.msg === "string") return d.msg;
  return fallback;
}

export function hexToRgb(hex) {
  const m = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex || "");
  return m ? [parseInt(m[1], 16), parseInt(m[2], 16), parseInt(m[3], 16)] : null;
}

export function contrastRatio(hex1, hex2) {
  const lum = (hex) => {
    const rgb = hexToRgb(hex);
    if (!rgb) return null;
    const [r, g, b] = rgb.map((v) => {
      const s = v / 255;
      return s <= 0.03928 ? s / 12.92 : Math.pow((s + 0.055) / 1.055, 2.4);
    });
    return 0.2126 * r + 0.7152 * g + 0.0722 * b;
  };
  const l1 = lum(hex1), l2 = lum(hex2);
  if (l1 == null || l2 == null) return null;
  return (Math.max(l1, l2) + 0.05) / (Math.min(l1, l2) + 0.05);
}

export function suggestReadableText(bgHex) {
  const white = contrastRatio(bgHex, "#ffffff") || 0;
  const dark = contrastRatio(bgHex, "#1f2937") || 0;
  return white >= dark ? "#ffffff" : "#1f2937";
}
